/**
 * Validates Spanish citizen IDESP/Support Number format
 * Format: 3 alphanumeric characters + 6 digits (e.g. AAA123456)
 */
const isValidSpanishSupportNumber = (value) => {
    if (!value) return false;
    const regex = /^[A-Z0-9]{3}\d{6}$/;
    return regex.test(value);
};

/**
 * Validates foreign citizen identification card number format
 * Format: 'E' + 8 digits matching foreign ID card number
 */
const isValidForeignSupportNumber = (value) => {
    if (!value) return false;
    const regex = /^E\d{8}$/;
    return regex.test(value);
};

/**
 * Validates communitary citizen support number format
 * Format: 'C' + 8 digits matching EU certificate number
 */
const isValidCommunitarySupportNumber = (value) => {
    if (!value) return false;
    const regex = /^C\d{8}$/;
    return regex.test(value);
};


/**
 * Validates if the support number matches either Spanish or foreign format
 */
const isValidSupportNumber = (value) => {
    return isValidSpanishSupportNumber(value) || isValidForeignSupportNumber(value);
};

export {
    isValidSpanishSupportNumber,
    isValidForeignSupportNumber,
    isValidCommunitarySupportNumber,
    isValidSupportNumber
};
